<script setup lang="ts">
import { onMounted, ref, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRules } from 'vuetify'
import type { VForm } from 'vuetify/components'

const email = defineModel<string>({ required: true })

defineProps<{
  loading: boolean
}>()

const emit = defineEmits<{
  submit: []
}>()

const { t } = useI18n()
const rules = useRules()
const formValid = ref<boolean | null>(null)
const form = useTemplateRef<VForm>('form')

onMounted(() => {
  // A pre-filled address (deep link, edit from step 2) shows its validity at once, not after the first keystroke.
  if (email.value !== '') void form.value?.validate()
})
</script>

<template>
  <v-form
    ref="form"
    v-model="formValid"
    @submit.prevent="emit('submit')"
  >
    <v-text-field
      v-model="email"
      :label="t('common.email')"
      :placeholder="t('common.enter_your_email_address')"
      :rules="[rules.required(), rules.email()]"
      type="email"
      autocomplete="username"
      class="mb-2"
    />
    <v-btn
      type="submit"
      color="primary"
      :loading="loading"
      :disabled="formValid !== true"
    >
      {{ t('common.continue') }}
    </v-btn>
  </v-form>
</template>
